module.exports = __webpack_public_path__ + "static/media/salon-1-min.c195dbb5.png";